import ngoProfileService from "../../services";

export default {
  namespaced: true,
  state: {
    logs: [],
    loading: false,
  },
  getters: {
    logs(state) {
      return state.logs;
    },
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLogs(state, payload) {
      state.logs = payload;
    },
  },
  actions: {
    async getLog(context) {
      context.state.loading = true;
      try {
        const data = await ngoProfileService.getLogs();
        context.commit("setLogs", data.data);
        context.state.loading = false;
      } catch (err) {
      } finally {
        context.state.loading = false;
      }
    },
  },
};
